export default defineNuxtPlugin(() => {
  // 等待 kwaiq 載入的 Promise
  const waitForKwaiq = () => {
    return new Promise((resolve) => {
      if (window.kwaiq && typeof window.kwaiq.load === 'function') {
        resolve(window.kwaiq)
        return
      }

      // 每 100ms 檢查一次，最多等待 10 秒
      let attempts = 0
      const maxAttempts = 100
      const interval = setInterval(() => {
        attempts++
        if (window.kwaiq && typeof window.kwaiq.load === 'function') {
          clearInterval(interval)
          resolve(window.kwaiq)
        } else if (attempts >= maxAttempts) {
          clearInterval(interval)
          console.warn('[kwaiq] SDK not loaded after 10 seconds')
          resolve({}) // 返回空對象作為 fallback
        }
      }, 100)
    })
  }

  // 立即返回一個代理對象，實際調用時會等待 kwaiq 載入
  const kwaiqProxy = new Proxy(
    {},
    {
      get(target, prop) {
        if (!target._kwaiq) {
          // 第一次訪問時開始等待
          target._promise =
            target._promise ||
            waitForKwaiq().then((kwaiq) => {
              target._kwaiq = kwaiq
              console.info('[kwaiq] SDK loaded successfully')
              return kwaiq
            })
        }

        return (...args) => {
          if (target._kwaiq && typeof target._kwaiq[prop] === 'function') {
            return target._kwaiq[prop](...args)
          }
          // 如果還在等待，先排隊
          return target._promise.then((kwaiq) => {
            if (kwaiq && typeof kwaiq[prop] === 'function') {
              return kwaiq[prop](...args)
            }
            console.warn(`[kwaiq] Method ${String(prop)} not available`)
          })
        }
      },
    }
  )

  return {
    provide: {
      kwaiq: kwaiqProxy,
    },
  }
})
